export default __webpack_public_path__ + "static/media/gamesglobal-mono.f914d016.svg";